import React from 'react';

import Avatar from "@material-ui/core/Avatar";

const MfaNumber = ({number}) => {
    return (
            <Avatar>{number}</Avatar>
    );
}
 
export {MfaNumber};